import { render, staticRenderFns } from "./AccreditationDetail.vue?vue&type=template&id=4c2f5f56&"
import script from "./AccreditationDetail.vue?vue&type=script&lang=js&"
export * from "./AccreditationDetail.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationDetail.vue?vue&type=style&index=0&id=4c2f5f56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports